<!--
 * @Author: liushumin
 * @Date: 2022-09-14 18:05:05
 * @LastEditTime: 2022-09-27 18:33:30
 * @LastEditors: liushumin
-->
<template>
  <el-dialog
    title="修改收货人信息"
    :visible.sync="dialogVisible_add"
    width="670px"
    :before-close="handleClose"
    class="szDialog"
  >
    <el-form
      :model="dynamicValAddForm"
      ref="dynamicValAddForm"
      class="demo-dynamic"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item prop="receiver" label="姓名">
            <el-input
              type="text"
              placeholder="收货人姓名"
              style="width: 60%"
              v-model="dynamicValAddForm.receiver"
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="telphone" label="手机号">
            <el-input
              type="text"
              placeholder="手机号码"
              style="width: 60%"
              v-model="dynamicValAddForm.telphone"
              maxlength="11"
              oninput="value=value.replace(/[^0-9]/g,'')"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-row>
        <el-col :span="12">
          <el-form-item prop="code" label="邮政编码">
            <el-input
              type="text"
              placeholder="邮政编码"
              style="width: 60%"
              v-model="dynamicValAddForm.code"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row> -->

      <!-- <el-form-item prop="area" label="所在地区">
        <el-select
          v-model="dynamicValAddForm.area"
          placeholder="所在地区"
          style="width: 80%"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item prop="addr" label="详细地址">
        <el-input
          type="textarea"
          :rows="3"
          style="width: 80%"
          placeholder="完善详细地址"
          v-model="dynamicValAddForm.addr"
          maxlength="50"
        >
        </el-input>
      </el-form-item>
      <!-- <div class="invoice-box" style="margin-left: 100px">
        <el-checkbox v-model="checked1">设置默认</el-checkbox>
      </div> -->
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button
        type="primary"
        :disabled="stepLoading"
        @click="submitForm('dynamicValAddForm')"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: ["openStatus", "infoShObj", "orderId"],
  data() {
    return {
      stepLoading: false,
      dialogVisible_add: false,
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      dynamicValAddForm: {
        receiver: "",
        telphone: "",
        // area: "",
        addr: "",
        orderId: "",
        // code: "",
      },
      checked1: false,
    };
  },
  watch: {
    openStatus(val1, val2) {
      this.dialogVisible_add = this.openStatus;
    },
    "$store.state.szStatus.receiverObj": {
      deep: true,
      handler(newValue, oldValue) {
        this.dynamicValAddForm = newValue;
        this.dynamicValAddForm.orderId = this.orderId;
      },
    },
    orderId(val1, val2) {
      this.dynamicValAddForm.orderId = val1;
    },
  },
  // created() {
  //   // this.dynamicValAddForm = JSON.parse(sessionStorage.getItem("infoShObj"))[0];
  //   this.dynamicValAddForm.orderId = this.orderId;
  // },
  mounted() {
    console.log(this.orderId);
    this.dynamicValAddForm = this.$store.state.szStatus.receiverObj;
    this.dynamicValAddForm.orderId = sessionStorage.getItem("orderId");
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.cancelOrderList();
        } else {
          return false;
        }
      });
    },
    // 修改收货人信息接口
    cancelOrderList() {
      this.stepLoading = true;
      this.$http.szOrder.editConsignee(this.dynamicValAddForm).then((res) => {
        this.stepLoading = false;
        if (res.status == 1) {
          this.dialogVisible_add = false;
          this.$emit("closeStatus", true);
          this.$message({
            message: "修改成功",
            type: "success",
          });
          setTimeout(() => {
            this.stepLoading = false;
          }, 1000);
        }
      });
    },
    handleClose() {
      this.dialogVisible_add = false;
      this.$emit("closeStatus", true);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../../../styles/order-global.scss";
</style>
